import { render, staticRenderFns } from "./PZNotice.vue?vue&type=template&id=e30fba5e&scoped=true"
import script from "./PZNotice.vue?vue&type=script&lang=js"
export * from "./PZNotice.vue?vue&type=script&lang=js"
import style0 from "./PZNotice.vue?vue&type=style&index=0&id=e30fba5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30fba5e",
  null
  
)

export default component.exports